import { useCallback, useEffect, useState } from 'react';

const MOBILE_MAX_WIDTH_RESOLUTION = 768;

const isBelowResolution = (): boolean => window.innerWidth <= MOBILE_MAX_WIDTH_RESOLUTION;

export const useMobile = () => {
  const [isMobile, setIsMobile] = useState<boolean>(isBelowResolution());

  const checkIfMobile = useCallback(() => {
    const newIsMobile = isBelowResolution();

    if (isMobile === newIsMobile) {
      return;
    }

    setIsMobile(newIsMobile);
  }, [isMobile]);

  useEffect(() => {
    window.addEventListener('resize', checkIfMobile);
    return () => {
      window.removeEventListener('resize', checkIfMobile);
    };
  }, [isMobile]);

  return { isMobile };
};
